if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.variantSelects = this.querySelector('variant-selects');
        if (!this.variantSelects) return;

        this.productUrl = this.dataset.productUrl;
        const variantsJson = this.variantSelects.querySelector('[type="application/json"]');
        if (variantsJson) {
          this.variants = JSON.parse(variantsJson.textContent);
        }

        this.onVariantChange = this.onVariantChange.bind(this);
        this.variantSelects.addEventListener('change', this.onVariantChange);
      }

      disconnectedCallback() {
        if (this.variantSelects) {
          this.variantSelects.removeEventListener('change', this.onVariantChange);
        }
      }

      onVariantChange() {
        if (!this.variants) return;

        let selectedOptions = [];
        const fieldsets = this.variantSelects.querySelectorAll('fieldset');

        // if there are no fieldsets, it's a dropdown
        if (fieldsets.length === 0) {
          const selects = this.variantSelects.querySelectorAll('select');
          selects.forEach((select) => {
            selectedOptions.push(select.value);
          });
        } else {
          fieldsets.forEach((fieldset) => {
            const input = fieldset.querySelector('input:checked');
            if (input) {
              selectedOptions.push(input.value);
            }
          });
        }

        const selectedVariant = this.variants.find((variant) => {
          const areEqual = JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
          return areEqual;
        });

        if (!selectedVariant) return;

        this.fetchProductCard(selectedVariant.id);
      }

      fetchProductCard(variantId) {
        const url = `${this.productUrl}?variant=${variantId}&section_id=product-card-horizontal`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newCard = html.querySelector('product-card');
            if (newCard) {
              this.parentElement.replaceChild(newCard, this);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
